<template>
	<b-card id="card">
    <div class="w-100 button-with-alert" v-if="!loading.mySession">
      <span :title="$t('Subir archivo')" v-b-tooltip.bottom.hover class="float-right mr-1"><b-button variant="warning" @click="openModal('new')"> <feather-icon icon="UploadFileIcon" /> Nueva tarifa </b-button></span>
    </div>
		<form-render
			ref="formRenderCustomTariff"
      id="formCustomTariff"
			:key="keyCustomTariff"
			:fields="fields"
			:form.sync="form"
			containerButtonsClass="col-12 mt-2 mr-1 pl-0 pr-0 text-right buttons-custom-tariff"
      class="m-1"
      v-if="!loading.mySession"
		>
			<template #buttons>
        <b-button variant="warning" v-b-tooltip.hover title="Buscar" :disabled="loading.customTariff" @click="ok">
          <feather-icon v-if="!loading.customTariff" icon="SearchIcon"/>
          <b-spinner v-if="loading.customTariff" small />
        </b-button>
				<b-button variant="outline-light" v-b-tooltip.hover title="Limpiar filtros" class="ml-1 mr-1" @click="cleanFilter">
					<feather-icon icon="RefreshCwIcon" />
				</b-button>
			</template>
		</form-render>
		<div v-if="loading.customTariff">
			<b-skeleton height="40px" width="`calc(100vh - 2.5rem)`" class="mt-1 mb-1" />
			<div class="table-skeleton-tableQuoter">
				<b-skeleton-table :rows="5" :columns="6" :table-props="{ }" />
			</div>
		</div>
    <div v-if="loading.mySession" class="d-flex">
      <b-skeleton width="25%" type="input" class="m-1"/>
      <b-skeleton width="25%" type="input" class="m-1"/>
      <b-skeleton width="25%" type="input" class="m-1"/>
      <b-skeleton width="25%" type="input" class="m-1"/>
    </div>
    <TableCustomTariff :data="dataTable" v-if="!loading.customTariff && showTable" ref="TableCustomTariff" @openModal="openModal" @getRates="sendForm"/>
    <ModalCustomCoverages ref="ModalCustomCoverages" v-if="isOpenModalCustomCoverages" @hideModal="hideModal" :data="dataModalCustomCoverages" @getRates="sendForm"/>
	</b-card>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseServices from '@/store/services/index'
import TableCustomTariff from './components/TableCustomTariff.vue'
import ModalCustomCoverages from './components/ModalCustomCoverages.vue'

export default {
  components: {TableCustomTariff, ModalCustomCoverages},
  name: 'Custom-Tariff',
  data () {
    return {
      baseService: new BaseServices(this),
      keyCustomTariff: 0,
      form: {},
      fields: [],
      role: '',
      buttonSend: { icon: 'SearchIcon', title: 'Buscar', color: 'warning', disabled: false },
      loading: {
        mySession: true,
        customTariff: false
      },
      showTable: false,
      rows: [],
      fieldCountryIdSeller: { fieldType: 'FieldSelect', useSkeleton: true, useLabel: true, label: this.$t('ID/Nombre empresa o mkp'), name: 'countryIdSeller', id: 'countryIdSeller', validation: 'required', containerClass: 'col-4 col-sm-3 col-md-2 col-lg-1 country-id-seller fieldSelect', change: this.changeCountryIdSeller, addFlags: true, sort: true, placeholder: 'País', clearable: false, onlyFlag: true },
      fieldIdSeller: { fieldType: 'FieldSelect', name: 'seller', useLabel: true, label: '.', validation: 'required', containerClass: 'col-8 col-sm-9 col-md-4 col-lg-2 field-id-seller fieldSelect', dependency: 'countryIdSeller', clearable: true, placeholder: 'Seleccione ID/Nombre empresa o mkp', searchOnType: { fx: this.setSeller, nChars: 2, debounce: 600 }, change: this.changeSeller },
      fieldApplication: { fieldType: 'FieldSelect', useSkeleton: false, useLabel: true, label: 'Nombre Aplicación', name: 'application', validation: 'required', dependency: 'countryIdSeller', containerClass: 'col-sm-12 col-md-6 col-lg-3 fieldSelect', sort: true, clearable: true, change: this.changeApplications },
      fieldOrigin: { fieldType: 'FieldSelect', label: 'Origen', useLabel: true, name: 'origin', validation: 'required', containerClass: 'col-sm-12 col-md-6 col-lg-3 fieldSelect', dependency: 'countryIdSeller', clearable: true, searchOnType: { fx: this.setPlacesOrigins, nChars: 3, debounce: 600, persistSearch: true }, sort: true, change: this.changeOrigins},
      fieldDestination: { fieldType: 'FieldSelect', name: 'destination', useLabel: true, label: 'Destino', containerClass: 'col-sm-12 col-md-6 col-lg-3 destination-custom-tariff fieldSelect', dependency: 'origin', clearable: true, searchOnType: { fx: this.setPlaces, nChars: 3, debounce: 600, persistSearch: true }, sort: true, useSkeleton: false, change: this.changeDestinations },
      dataTable: { form: {}, rows: [] },
      isOpenModalCustomCoverages: false,
      dataModalCustomCoverages: {},
      allApplyApplications: [{ id: '1', text: 'Test 1' }, { id: '2', text: 'Test 2' }, { id: '3', text: 'Test 3' }],
      currentRate: null,
      pagination: {
        page: 1,
        total: 0,
        limit: 20
      }

    }
  },
  computed: {
    ...mapGetters({
      mySession: 'getSession',
      countries: 'getCountriesCoverage',
      applications: 'getApplications',
      generalLoading: 'getLoading',
      historyRates: 'getHistoryCustomizedRates',
      tariff: 'getTariffCustomizedRates'
    })
  },
  watch: {
    mySession () {
      if (this.loading.mySession) {
        this.setInitialData()
      }
    },
    countries() {
      this.setOptions(this.fields, 'countryIdSeller', this.countries.rows)
    },
    applications() {
      this.setOptions(this.fields, 'application', this.applications.rows)
    },
    historyRates() {
      this.currentRate = this.historyRates.rows.filter(el => el.type === 'current')
      this.getTariff()
    },
    tariff() {
      this.setTariff()
    },
    generalLoading: {
      handler () {
      },
      deep: true
    }
  },
  mounted () {
    if (this.loading.mySession && this.$session.get('cas_user')) {
      this.setInitialData()
    }
  },
  methods: {
    setInitialData () {
      this.loading.mySession = false
      this.role = this.$session.get('cas_user').role
      this.setFields()
      this.$store.dispatch('fetchService', { name: 'getCountriesCoverage' })
    },
    setFields() {
      const containerButtons = document.querySelector('.buttons-custom-tariff')
      if (this.role === 'admin') {
        this.fieldApplication.dependency = 'seller'
        if (containerButtons) {
          containerButtons.classList.add('col-12', 'mr-1', 'text-right')
          containerButtons.classList.remove('col-3')
        }
        this.fields = [
          this.fieldCountryIdSeller,
          this.fieldIdSeller,
          this.fieldApplication,
          this.fieldOrigin,
          this.fieldDestination
        ]
      } else if (this.role === 'marketplace' || this.role === 'ecommerce') {
        this.form.countryIdSeller = this.$session.get('cas_user').country
        delete this.fieldApplication.dependency
        if (containerButtons) {
          containerButtons.classList.add('col-3')
          containerButtons.classList.remove('mr-1', 'text-right')
        }
        this.fields = [
          this.fieldApplication,
          this.fieldOrigin,
          this.fieldDestination
        ]
        this.changeSeller('seller', this.$session.get('cas_user').organization)
      } else {
        this.$router.push({ name: '/404' })
      }
    },
    setPlacesOrigins(value) {
      delete this.form.origin
      return this.setPlaces(value)
    },
    async setPlaces(value) {
      const queryParams = {
        country_id: this.form.countryIdSeller.id,
        company_id: this.form.seller.id,
        marketcenter_id: this.form.application.id,
        search: value
      }
      if (this.form.origin) {
        queryParams.from_place_id = this.form.countryIdSeller.code === 'MX' ? this.form.origin.parent_id : this.form.origin.id
      }
      return await this.baseService.callService('getOriginsCustomizedRates', queryParams)
        .then(resp => { return resp.data.map(el => ({...el, text: el.full_name, valid: true})) })
        .catch(err => { return err })
    },
    setOptions(fields, name, options) {
      if (this.m_getElementIndex(fields, 'name', name) !== -1) {
        this.fields[this.m_getElementIndex(fields, 'name', name)].options = options
        this.fields[this.m_getElementIndex(fields, 'name', name)].useSkeleton = false
      }
    },
    async setSeller(value) {
      const params = {
        country_id: this.form.countryIdSeller.id
      }
      const queryParams = {
        country_code: this.form.countryIdSeller.code,
        search: value,
        in_coverage: true
      }
      return await this.baseService.callService('getCompaniesCustomizedRates', queryParams, params)
        .then((resp) => resp.data.map((el) => ({...el, text: el.name })))
        .catch((err) => err)
    },
    setTariff() {
      this.rows = this.tariff.rows.map((el) => {
        if (this.form.countryIdSeller.code === 'PE') {
          el.dest_full_name = `${el.dest_place_code}, ${el.dest_full_name}`
        }
        const arrayPlace = el.dest_full_name.split(',').map(parte => parte.trim())
        const weightIntervals = Object.keys(el.weight_intervals)
        const weights = {}
        weightIntervals.forEach(weight => {
          weights[weight] = el.weight_intervals[weight].pf
        })
        return {
          ...el,
          ...weights,
          level0: arrayPlace[0] || '',
          level1: arrayPlace[1] || '',
          level2: arrayPlace[2] || '',
          level3: arrayPlace[3] || '',
          options: [{ text: 'Eliminar tarifa', id: 'delete' }, { text: 'Editar tarifa', id: 'edit' }],
          moreActions: ''
        }
      })
      this.loading.customTariff = false
      this.showTable = true
      this.dataTable = { form: this.form, rows: this.rows, rates: this.currentRate[0] }
      this.$nextTick(() => {
        this.$refs.TableCustomTariff.setInitialData()
      })
    },
    getTariff() {
      if (this.currentRate.length) {
        const queryParams = {
          customized_rate_id: this.currentRate[0].id,
          from_place_id: this.form.countryIdSeller.code === 'MX' ? this.form.origin.parent_id : this.form.origin.id,
          page: this.pagination.page,
          page_size: this.pagination.limit
        }
        if (this.form.destination) {
          queryParams.to_place_id = this.form.countryIdSeller.code === 'MX' ? this.form.destination.parent_id : this.form.destination.id
        }
        this.$store.dispatch('fetchService', { name: 'getTariffCustomizedRates', queryParams, onError: () => { this.loading.customTariff = false } })
      }
    },
    changeCountryIdSeller(name, value) {
      this.cleanFields(['seller', 'application', 'origin', 'destination'])
      this.showTable = false
    },
    changeSeller(name, value) {
      this.fields[this.m_getElementIndex(this.fields, 'name', 'application')].useSkeleton = true
      this.fields[this.m_getElementIndex(this.fields, 'name', 'application')].options = []
      delete this.form.application
      this.showTable = false
      if (value?.id) {
        this.$store.dispatch('fetchService', { name: 'getApplications', queryParams: { company_id: value.id, in_coverage: true } })
      }
      this.cleanFields(['origin', 'destination'])
      if (!value) this.fields[this.m_getElementIndex(this.fields, 'name', 'application')].useSkeleton = false
    },
    changeApplications(name, value) {
      this.cleanFields(['origin', 'destination'])
      this.showTable = false
    },
    changeOrigins(name, value) {
      this.cleanFields(['destination'])
      this.showTable = false
    },
    changeDestinations(name, value) {
      this.showTable = false
    },
    cleanFields(elements) {
      elements.forEach((el) => {
        delete this.form[el]
        this.fields[this.m_getElementIndex(this.fields, 'name', el)].useSkeleton = true
        setTimeout(() => {
          this.fields[this.m_getElementIndex(this.fields, 'name', el)].useSkeleton = false
        }, 100)
      })
    },
    cleanFilter() {
      this.form = {}
      this.showTable = false
    },
    async ok() {
      const check = await this.$refs.formRenderCustomTariff.onlyCheckForm()
      if (check) this.sendForm()
    },
    sendForm(type) {
      this.loading.customTariff = true
      const queryParams = {
        company_id: this.form.seller.id,
        marketcenter_id: this.form.application.id
      }
      if (type?.isEdit) {
        setTimeout(() => {
          this.$store.dispatch('fetchService', { name: 'getHistoryCustomizedRates', queryParams, onError: () => { this.loading.customTariff = false } })
        }, 1000)
      } else if (type?.isDelete) { 
        this.cleanFields(['seller', 'application', 'origin', 'destination'])
        setTimeout(() => this.loading.customTariff = false, 100)
        this.showTable = false
      } else {
        this.$store.dispatch('fetchService', { name: 'getHistoryCustomizedRates', queryParams, onError: () => { this.loading.customTariff = false } })
      }
    },
    openModal(isNew) {
      this.isOpenModalCustomCoverages = true
      this.dataModalCustomCoverages = { 
        form: this.form, countries: this.countries.rows,
        allApplyApplications: this.allApplyApplications,
        session: this.$session.get('cas_user'),
        isNew: !!(isNew === 'new')
      }
      if (this.currentRate) this.dataModalCustomCoverages.rates = this.currentRate[0]
      this.$nextTick(() => {
        this.$bvModal.show('ModalCustomCoverages')
        this.$refs.ModalCustomCoverages.setInitialData()
      })
    },
    hideModal() {
      this.isOpenModalCustomCoverages = false
    }
  }
}
</script>
<style lang="scss">
  .country-id-seller {
    // width: 100px !important;
    min-width: 80px !important;
    padding-left: 1em;
    padding-right: 0;
    div {
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
      label {
        width: max-content;
      }
    }
  }
  .field-id-seller {
    padding-left: 0;
    div {
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
      label {
      visibility: hidden;
      }
    }
  }
</style>